// @flow
import React, { Fragment, useContext } from 'react';

import { descriptorsLibrary } from 'Client/cms/toolkit/descriptors';
import { ABTestContext } from 'Context/ABTestContext';
import ReactResponsiveContext from 'Components/utils/responsive/responsiveContext';
import { type LineProps } from 'Components/frameworks/line/Line';

type Props = {
  name: string,
  lines: $ReadOnlyArray<LineProps>,
};

export const TestAB = (props: Props) => {
  const tests = useContext(ABTestContext);
  const { isAppMounted } = useContext(ReactResponsiveContext);

  if (!isAppMounted) {
    return null;
  }

  const idx = tests[props.name] ? Number(tests[props.name]) : 0;
  const variation = props.lines[!Number.isNaN(idx) ? idx : 0];
  const VariationComponent = descriptorsLibrary[variation.name].component;

  return (
    <Fragment>
      <VariationComponent {...variation.props} />
    </Fragment>
  );
};
